module.exports = __webpack_public_path__ + "img/bg_loaded_small.415d00f4.png";